import React from "react";

function MaintenanceCard(props) {
  return (
    <div>
      <input
        onChange={(e) => {
          props.onClick();
        }}
        type="radio"
        name="name"
        id={props.id}
        checked={props?.checked}
      />
      <label htmlFor={String(props.id)}>
        <img src={props.imgsrc} alt="" />
        {props.title}
      </label>
    </div>
  );
}

export default MaintenanceCard;
